import React from 'react';
import DescribeActivityVoiceContainer from './DescribeActivityVoiceContainer';
import {
  TrackerEstimateBurnedCaloriesConnectorApollo,
  withMobileAppMode,
} from '@front-activerse/common-components';
import { useLocation } from 'react-router-dom';
import TrackerNoAccess from '../NoAccess/TrackerNoAccess';

const DescribeActivityVoicePage: React.FC<{ mobileAppMode: boolean }> = ({ mobileAppMode }) => {
  const location = useLocation();

  const aiAccess = sessionStorage.getItem('aiAccess');

  if (aiAccess === 'true' || mobileAppMode) {
    return (
      <TrackerEstimateBurnedCaloriesConnectorApollo>
        {({ estimateBurnedKcals, cancelEstimateBurnedKcals }) => (
          <DescribeActivityVoiceContainer
            estimateBurnedKcals={estimateBurnedKcals}
            cancelEstimateBurnedKcals={cancelEstimateBurnedKcals}
            key={location.key} // Force re-render
          />
        )}
      </TrackerEstimateBurnedCaloriesConnectorApollo>
    );
  }
  return <TrackerNoAccess />;
};

export default withMobileAppMode(DescribeActivityVoicePage);
